import { KText } from '@/ui-library/components';
import {
  Flex,
  TabList,
  Tab,
  Tabs,
  TabPanels,
  TabPanel,
  Switch,
  FormLabel,
  FormControl,
} from '@chakra-ui/react';
import { useSearchManager } from './search-manager';
import { Link } from 'react-router-dom';
import { useSearchTabs } from './useSearchTabs';
import { EmptyResults } from '../ats';
import { NoSearchResult } from '@/assets/icons/ats/empty';
import { useSearchHelper } from './useSearchHelper';
import { RESUME_SEARCH_STORAGE_KEY } from './constant';

export const SearchResultsTabs = () => {
  const {
    searchResults,
    currentTab,
    setCurrentTab,
    handleKeyDown,
    searchTerm,
    onSearchClose,
    includeResume,
    setIncludeResume,
    setSearchResults,
    setIsSearchLoading,
  } = useSearchManager();
  const { visibleTabs } = useSearchTabs(searchResults);
  const { handleResumeSearch } = useSearchHelper();

  return (
    <Flex onKeyDown={(e) => handleKeyDown(e)}>
      <Tabs
        display="flex"
        flexDir="column"
        flex="1"
        h="100%"
        overflowY="hidden"
        alignItems="stretch"
        index={visibleTabs?.findIndex((option) => option?.id === currentTab)}
        isLazy={true}
      >
        <TabList
          sx={{ borderBottom: '1px solid', borderColor: 'border-color' }}
          px="16px"
          gap="30px"
          h="50px"
          pt="12px"
        >
          {visibleTabs.map((option) => {
            return (
              <Tab
                key={option?.id}
                _active={{ boxShadow: '' }}
                _focus={{ boxShadow: '' }}
                _selected={{
                  color: 'primary-500',
                  borderColor: 'primary-500',
                  fontWeight: 'bold',
                }}
                onClick={() => setCurrentTab(option?.id)}
                alignItems="center"
                px="0"
                color="secondary-700"
                fontWeight="medium"
              >
                <KText
                  color="inherit"
                  variant="heading_4"
                  p="2px 6px"
                  borderRadius="xs"
                  bg="ats-tertiary"
                  mr="8px"
                  minH="20px"
                  textAlign="center"
                  fontWeight="inherit"
                >
                  {option?.count}
                </KText>
                <KText color="inherit" variant="heading_4" fontWeight="inherit">
                  {option?.text}
                </KText>
              </Tab>
            );
          })}
        </TabList>
        <TabPanels h="100%" overflowY="hidden">
          {visibleTabs.map((option) => {
            const {
              id,
              data,
              itemComponent: ItemComponent,
              count,
              route,
              text,
            } = option;
            return (
              <TabPanel
                px="14px"
                py="0"
                key={id}
                h="100%"
                overflowY="hidden"
                flex="1"
              >
                <Flex
                  borderBottom="1px solid"
                  borderColor="secondary-100"
                  alignItems="center"
                  px="8px"
                  minH="52px"
                  justifyContent="space-between"
                >
                  <KText variant="overhead" my="15px">
                    Results
                  </KText>
                  <Flex alignItems="center" gap="12px">
                    {currentTab === 'contacts' && (
                      <FormControl display="flex" alignItems="center" gap="6px">
                        <Switch
                          className={`ats-switch-toogle ${
                            includeResume ? 'active' : ''
                          }`}
                          isChecked={includeResume}
                          onChange={() => {
                            const newValue = !includeResume;
                            setIncludeResume(newValue);
                            localStorage.setItem(
                              RESUME_SEARCH_STORAGE_KEY,
                              String(newValue)
                            );
                            handleResumeSearch({
                              searchTerm,
                              setIsSearchLoading,
                              setSearchResults,
                              permittedTabIds: ['contacts'],
                              includeResume: newValue,
                              searchResults,
                            });
                          }}
                          id="resume-search"
                        />
                        <FormLabel
                          mb="0"
                          mr="0"
                          htmlFor="resume-search"
                          cursor="pointer"
                        >
                          <KText variant="paragraph">Search resumes only</KText>
                        </FormLabel>
                      </FormControl>
                    )}
                    {count > 0 && (
                      <Link
                        to={`${route}?search=${encodeURIComponent(searchTerm)}${
                          currentTab !== 'flows' ? '&from=global-search' : ''
                        }${
                          includeResume && currentTab === 'contacts'
                            ? '&includeResume=true'
                            : ''
                        }`}
                        onClick={() => {
                          onSearchClose();
                        }}
                      >
                        <Flex alignItems="center" gap="4px">
                          <KText variant="link" my="15px" whiteSpace="nowrap">
                            See all {text.toLowerCase()}
                          </KText>
                        </Flex>
                      </Link>
                    )}
                  </Flex>
                </Flex>

                {data?.length > 0 ? (
                  <Flex
                    flexDir="column"
                    gap="6px"
                    minH="450px"
                    maxH="450px"
                    overflowY="auto"
                    my="12px"
                  >
                    {data?.map((item) => {
                      return <ItemComponent key={item.id} item={item} />;
                    })}
                  </Flex>
                ) : (
                  <EmptyResults
                    icon={NoSearchResult}
                    text={`Sorry, there are no results for your search. Try again with a different keyword.`}
                    subText={`No results`}
                    iconProps={{ h: '170px', w: '150px', mb: '0px' }}
                    wrapperProps={{ h: '450px' }}
                    textProps={{
                      size: 'sm-medium',
                      color: 'secondary-600',
                      maxW: '350px',
                      textAlign: 'center',
                    }}
                    subTextProps={{
                      size: 'lg-semi-bold',
                      color: 'secondary-900',
                    }}
                  />
                )}
              </TabPanel>
            );
          })}
        </TabPanels>
      </Tabs>
    </Flex>
  );
};
